/**
 * Returns the tabindex based on the element being focusable or not when navigating with the keyboard
 * -1 = element is not focusable
 * 0 = element is focusable
 *
 * @param isFocusable
 * @returns undefined | 0 | -1
 */
export const getTabIndex = (isFocusable: boolean | undefined) => {
  if (isFocusable === undefined) {
    return undefined;
  }

  return isFocusable ? 0 : -1;
};
